import { gql } from '@apollo/client';

import { studentFragment } from '../fragments';

export default gql`
  query GetStudentsByCourse($courseId: String!) {
    students(courseId: $courseId)
      @rest(type: "Student", path: "courses/{args.courseId}/students") {
      ...Student
    }
  }
  ${studentFragment}
`;
